import React from "react";

export const SunnyIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="32" fill="#3F4447">
                <g transform="translate(2.000000, 2.000000)">
                    <path
                        d="M75.2 41.78c.81 0 1.467-.648 1.467-1.447 0-.8-.657-1.447-1.467-1.447h-6.844c-.81 0-1.467.647-1.467 1.447s.657 1.447 1.467 1.447H75.2zM11.644 41.78c.81 0 1.467-.648 1.467-1.447 0-.8-.657-1.447-1.467-1.447H4.8c-.81 0-1.467.647-1.467 1.447S3.99 41.78 4.8 41.78h6.844zM64.36 66.903a1.48 1.48 0 002.074 0 1.434 1.434 0 000-2.047l-4.84-4.776a1.48 1.48 0 00-2.074 0 1.434 1.434 0 000 2.047l4.84 4.776zM18.406 21.552a1.48 1.48 0 002.074 0 1.434 1.434 0 000-2.047l-4.84-4.776a1.48 1.48 0 00-2.074 0 1.434 1.434 0 000 2.047l4.84 4.776zM39.023 75.553c0 .799.657 1.447 1.467 1.447s1.466-.648 1.466-1.447v-6.755c0-.8-.656-1.447-1.466-1.447-.81 0-1.467.648-1.467 1.447v6.755zM39.023 11.868c0 .8.657 1.448 1.467 1.448s1.466-.648 1.466-1.448V5.114c0-.8-.656-1.447-1.466-1.447-.81 0-1.467.648-1.467 1.447v6.754zM13.566 64.856a1.434 1.434 0 000 2.047 1.48 1.48 0 002.074 0l4.84-4.777a1.434 1.434 0 000-2.046 1.48 1.48 0 00-2.074 0l-4.84 4.776zM59.522 19.505a1.434 1.434 0 000 2.047 1.48 1.48 0 002.074 0l4.84-4.776a1.434 1.434 0 000-2.047 1.48 1.48 0 00-2.075 0l-4.84 4.776zM39.512 63.01c-12.428 0-22.489-10.16-22.489-22.676 0-12.516 10.061-22.676 22.49-22.676C51.94 17.658 62 27.818 62 40.334c0 12.516-10.06 22.675-22.489 22.675zm0-2.895c10.793 0 19.556-8.85 19.556-19.781 0-10.932-8.763-19.78-19.556-19.78-10.792 0-19.555 8.848-19.555 19.78s8.763 19.78 19.555 19.78z"
                        fill="#FCBA38"
                    />
                </g>
            </g>
        </g>
    </svg>
);
